import PlatformActions from './PlatformActions'

export default class JILISLOTActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameName: 'RomaX',
      gameCode: 'JILI-SLOT-040',
      platform: 'JILI',
    }

    this.constantTxnData_jackpot = {
      gameType: 'SLOT',
      gameName: 'Roma X Deluxe',
      gameCode: 'JILI-SLOT-124',
      platform: 'JILI',
    }
  }

  getBetNSettleMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      updateTime,
      jackpotWinAmount,
    }) => ({
      ...(jackpotWinAmount == null ? this.constantTxnData : this.constantTxnData_jackpot),
      userId,
      platformTxId: txnId, // 1700484850674810006
      roundId: txnId, // 1700484850674 810006
      betType: null,
      currency,
      betTime, // 2021-10-01T14:09:37.000+08:00
      txTime: betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: jackpotWinAmount ?? 0,
      updateTime, // 2021-10-01T14:09:37.230+08:00
      requireAmount: betAmount,
      gameInfo: {
        isEndRound: true,
        isBuyFreeSpin: false,
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetNSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId,
      roundId: txnId,
      updateTime,
      betAmount,
      gameInfo: {
        isEndRound: true,
        isBuyFreeSpin: false,
      },
    }))

    const message = {
      action: 'cancelBetNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getGiveMessage(txnList) {
    const { currency } = this.formData

    const txns = txnList.map(({
      userId,
      betAmount,
      promotionTxId,
      txTime,
    }) => ({
      platform: this.constantTxnData.platform,
      currency,
      userId,
      amount: betAmount,
      promotionTxId: `${promotionTxId}`, // 1700763682038580006
      promotionId: '1337',
      promotionTypeId: '37',
      txTime, // 2025-04-14T15:08:50.000+08:00
    }))

    const message = {
      action: 'give',
      txns,
    }

    return JSON.stringify(message)
  }
}
